module.exports = __webpack_public_path__ + "band_13.7199f968.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_13.png
// module id = nYB1
// module chunks = 0